import React from "react";
import { useSelector } from "react-redux";
import {
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
} from "../../utils/permissions";

const FeaturePermission = ({
  children,
  permission,
  anyPermission,
  allPermissions,
  checkPermission,
  fallback = null,
  hideIfNoPermission = true,
}) => {
  const admin = useSelector((state) => state.admin.txtconnect_ng_admin);

  if (!admin) {
    return hideIfNoPermission ? null : fallback;
  }

  let hasAccess = false;

  if (checkPermission) {
    hasAccess = checkPermission(admin);
  } else if (permission) {
    hasAccess = hasPermission(admin, permission);
  } else if (anyPermission && Array.isArray(anyPermission)) {
    hasAccess = hasAnyPermission(admin, anyPermission);
  } else if (allPermissions && Array.isArray(allPermissions)) {
    hasAccess = hasAllPermissions(admin, allPermissions);
  } else {
    hasAccess = true;
  }

  if (!hasAccess) {
    return hideIfNoPermission ? null : fallback;
  }

  return <>{children}</>;
};

export default FeaturePermission;
